import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fc83cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "signup",
  class: "rel of-hd"
}
const _hoisted_2 = {
  class: "flex-cen sign_page",
  style: {"width":"1440px","margin":"auto"}
}
const _hoisted_3 = { class: "signup-right" }

import { ref, onMounted, watch, computed } from 'vue'
import { useRouter, useRoute, RouteLocationNormalizedLoaded } from 'vue-router'
import {
  setDefault,
  setLaterDefault,
  registerPageImageQuery
} from '@/apis/login'
import { useStore } from 'vuex'
import { PlatProps, Site, UseType } from '@/common/const'
import ContactModal from './components/ContactModal.vue'
import Header from './components/header.vue'
import SignupForm from '@/components/Signup/form.vue'
import SignIntroduce from './components/SignIntroduce.vue'
import { promotionPluginFn } from './util'
import { h5Width } from './const'
import { isEN, isJA, isKO, usePlat, useSite, useSite2Station } from '@/store'
import { TaEvent, taSetUser, taTrack } from '@/util/buryingPoint'
import { t } from '@/plugins/i18n'

interface registerPageImageQueryRsp {
  success: boolean
  msg: string
  code: string
  data: {
    stationCode: Site
    imageUrl: string
    jumpUrl: string
  }
}
/** 更改默认图片以及链接 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const isH5 = computed(() => route.path.includes('_h5'))
const { query } = route

if (query.channel) {
  /**
   * channel:0 作为独立推广者的渠道
   * channel:N(>0) 作为商务合作的渠道 1: aucfun
   */
  const matchs: any = {
    1: 'af0001'
  }
  store.commit('route/signupQuery', query)
  const match = matchs[query.channel?.toString()]
  if (match) {
    if (query.code?.toString().toLowerCase() !== match) {
      router.push('/404')
    }
  }
} else {
  const signupQuery = store.state.route.signupQuery
  if (signupQuery.channel) {
    router.push({ name: 'signup', query: signupQuery })
  }
}

const api = ref(setLaterDefault)

const anim = ['slideInRight', 'slideOutLeft'].map((v) => 'animated slow ' + v)

const clientHeight = ref(550)
let uuid = store.state.route.uuid
store.commit('route/uuid', '')

const signupFormRef = ref()

const defaultImageUrl =
  'https://img-jp.theckb.com/client/signup_1542412361103704065_1716183067733.png'

const itsumoJaBgImage = 'https://static-s.theckb.com/BusinessMarket/Client/signup/signup_bg.png?v=2'
const defaultJunpLink = 'https://s.theckb.com/hub/ec'
const bgImageUrl = ref(defaultImageUrl)
// 点击背景图，默认的跳转链接
const junpLink = ref(defaultJunpLink)
const goto = async (plat: PlatProps) => {
  const res = await api.value({
    uuid,
    systemSource: UseType.d2c
  })
  if (res.success) {
    taSetUser(res.data?.customerRespDTO, route)
    const w: any = window
    // 谷歌埋点事件
    w.gtag &&
      w.gtag('event', 'conversion', {
        send_to: 'AW-11219352534/QIE-COST2bIYENb35uUp'
      })
    // fb埋点
    w.fbq && w.fbq('track', 'signup', 'signup')
    console.log(query)
    if (query.thirdShopAuth) {
      await store.commit('route/token', res.data.token)
      // console.log(decodeURIComponent(query.redirect!.toString()))
      location.href = decodeURIComponent(query.redirect!.toString())
      return
    }
    if (query.redirect) {
      await store.commit('route/token', res.data.token)
      location.replace(decodeURIComponent(query.redirect.toString()))
      router.push(query.redirect.toString())
    } else {
      await store.commit('route/token', res.data.token)
      localStorage._ckb_is_signup_user = 'positive'
      localStorage.setItem('_reload_page_', Math.random().toString().slice(2))
      store.commit('route/plat', 'd2c')
      const lang = useSite()
      setTimeout(() => {
        location.href = lang === 'ja' ? '/welcome' : `/${lang}/welcome`

      }, 500)
    }
  }
}

const changeImgAndLink = async (site: 'ko' | 'ja' | 'en') => {
  const stationCode = {
    ja: Site.JA,
    ko: Site.KO,
    en: Site.EN
  }[site]

  const rsp = await registerPageImageQuery<
    { stationCode: Site },
    registerPageImageQueryRsp
  >({ stationCode })

  bgImageUrl.value = rsp?.data?.imageUrl || defaultImageUrl
  junpLink.value = rsp?.data?.jumpUrl || defaultJunpLink
}

watch(
  () => store.getters.site,
  (site: 'ko' | 'ja' | 'en') => {
    changeImgAndLink(site)
  }
)

/**
 * 根据站点和参数场景判断是跳转选择平台/B2B/D2C
 *  1.非日本站且有uuid 默认进入选择平台
 *  2.日本站需要看站点的来源信息
 */
const stepChange = () => {
  if (route.query.channelRedirect && route.query.redirect) {
    goto('b2b')
    return
  }
  // 默认b2b
  goto('b2b')
}

/** 注册成功逻辑 */
const onsuccess = (key: string, channel: string, data?: any) => {
  uuid = key
  // 设置默认平台
  api.value = setDefault
  // 默认都要选择平台
  stepChange()
  if (!data) return
  // todo 加个channel
  promotionPluginFn({
    loginName: data.loginName,
    email: data.customerEmail,
    device: 'pc',
    mobile: data.customerMobile,
    channel: channel,
    uuid: key
  })
}

const redirectToH5 = () => {
  if (window.screen?.availWidth < h5Width) {
    router.replace({
      path: '/signup_h5',
      query: route.query
    })
  }
}

const open = () => {
  // Itsumo禁止跳转
  if (isItsumoSignup.value) return
  window.open(junpLink.value, '__blank')
}

onMounted(async () => {
  window?.ECHAT?.closeMiniChat?.({ directClose: 1 })
  taTrack({
    event: TaEvent.PAGE_VIEW,
    value: {
      position: 'register_page'
    }
  })
  // 若是刚进来是别的站点的，需要执行一遍，不会触发watch方法
  const site = store.getters.site as 'ko' | 'ja' | 'en'
  changeImgAndLink(site)
  if (document.body.clientHeight >= 600) {
    clientHeight.value = document.body.clientHeight
  }
  if (uuid) {
    stepChange()
  }

  redirectToH5()
})
// 如果url 带?channel=itsumo 则不展示line图标
const isItsumoSignup = computed(() => route.query.channel === 'itsumo')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createVNode(_Transition, {
      "enter-active-class": _unref(anim)[0],
      "leave-active-class": _unref(anim)[1]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SignIntroduce),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(SignupForm, {
              ref: (_value, _refs) => {
                _refs['signupFormRef'] = _value
                signupFormRef.value = _value
              },
              onSuccess: onsuccess
            }, null, 512)
          ]),
          (!_unref(isItsumoSignup))
            ? (_openBlock(), _createBlock(ContactModal, {
                key: 0,
                h5: false,
                type: "signup"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["enter-active-class", "leave-active-class"])
  ]))
}
}

})